
import './medias-area.scss'

import { faCheck, faImage, faTimes, faTrash, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import Component from "vue-class-component";

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Media, MEDIA_DATA_CHANGED } from '@skinsoft/ui/src/item-card/media';
import { Touchable } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { 
    DELETE_IMAGE_CLICK_TOPIC,
    PRINCIPAL_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, 
    IMAGE_UPLOADED_TOPIC, 
    MEDIA_ID_CHANGED_FROM_CACHE, 
    MEDIA_END_LOADING_TOPIC,
 } from '@skinsoft/bus/src/busTopics'


export interface DeleteImageClickEvent {
    imageListIndex: number,
    imageId?: string
}

export interface ImageClickEvent {
    id: string,
    imageListIndex: number,
}

@Component({
    components: {
        sMedia: Media,
        sTouchable: Touchable
    },
    props: ['mediasIds', 'id', 'canUpload', 'inProgress'],
    template: require("./medias-area.html")
})
export class MediaArea extends ReactiveVue {

    // Allows to differentiate multiple instances of this component in the defect tree
    public id: string;
    public mediasIds: string[];
    public canUpload: boolean;
    public inProgress: boolean;
    public isSetDefaultImage: boolean;

    // Icons
    private addImageIcon = faImage;
    private deleteIcon = faTrash;
    private checkIcon = faCheck;
    private crossIcon = faTimes;
    private anglesUp = faAngleUp;

    private displayDeleteOverlayList: boolean[] = [];
    private displayDefaultImageOverlayList: boolean[] = [];
    private defaultImages: (string | null)[] = []

    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE
    private MEDIA_END_LOADING_TOPIC = MEDIA_END_LOADING_TOPIC
    private MEDIA_DATA_CHANGED = MEDIA_DATA_CHANGED
    

    private onDefaultImage(index){
        this.displayDefaultImageOverlayList[index] = !this.displayDefaultImageOverlayList[index]
        this.$forceUpdate()
    }

    public onDefaultImageClick(index) {
        this.$emit(PRINCIPAL_IMAGE_CLICK_TOPIC,  this.mediasIds[index])
        this.cancelDefaultImage(index)
    }

    public cancelDefaultImage(index) {
        this.displayDefaultImageOverlayList[index] = false
        this.$forceUpdate()
    }

    public onFileUploaded(event) {
        const name = "REP-"+Date.now()+"."+ event.target.files[0].name.split('.').pop()
        const myNewFile = new File([event.target.files[0]], name, {type: event.target.files[0].type});
        const reader = new FileReader()
        reader.readAsDataURL(myNewFile)
        reader.addEventListener("load", () => {
            // the event is emited by the component and on the bus for the following reason
            // on certain forms (EditReportScreen) there is 2 different components that features medias and using bus 
            // to listen to the image upload would cause the media to be added by both. On the other end emiting on bus
            // is usefull when some components have to react to media loading (validation button of forms) 
            this.$emit(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: myNewFile })
            this.emitOnBus(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: myNewFile })
        }, false)
    }

    public onImageClick(imageId, index) {
        this.$emit(IMAGE_CLICK_TOPIC, { id: imageId, imageListIndex: index })
    }

    public onTrashClick(index) {
        this.displayDeleteOverlayList[index] = !this.displayDeleteOverlayList[index]
        this.$forceUpdate()
    }


    public onDeleteImageClick(index) {
        const imageId = this.mediasIds[index]
        this.displayDeleteOverlayList.splice(index, 1)
        this.$emit(DELETE_IMAGE_CLICK_TOPIC, { imageListIndex: index, imageId: imageId } as DeleteImageClickEvent)
    }

    public onMediaDataChanged(mediaData: string, index: number) {
        this.defaultImages[index] = mediaData
    }

    public cancelDelete(index) {
        this.displayDeleteOverlayList[index] = false
        this.$forceUpdate()
    }

    @Watch('mediasIds')
    public onMediasIdsChange() {
        this.displayDeleteOverlayList.push(false);
        this.displayDefaultImageOverlayList.push(false);
    }
}